'use strict';

define(['utils/extendable', 'utils/ui', 'handlebars-loader!templates/slider.html', 'utils/helpers'], function (Extendable, UI, SliderTemplate, utils) {

    var Slider = Extendable.extend({
        constructor: function constructor(className, orientation) {
            this.className = className + ' jw-background-color jw-reset';
            this.orientation = orientation;

            this.dragStartListener = this.dragStart.bind(this);
            this.dragMoveListener = this.dragMove.bind(this);
            this.dragEndListener = this.dragEnd.bind(this);

            this.tapListener = this.tap.bind(this);

            this.setup();
        },
        setup: function setup() {
            var obj = {
                'default': this['default'],
                className: this.className,
                orientation: 'jw-slider-' + this.orientation
            };
            this.el = utils.createElement(SliderTemplate(obj));

            this.elementRail = utils.getElementsByClassName('jw-slider-container', this.el)[0];
            this.elementBuffer = utils.getElementsByClassName('jw-buffer', this.el)[0];
            this.elementProgress = utils.getElementsByClassName('jw-progress', this.el)[0];
            this.elementThumb = utils.getElementsByClassName('jw-knob', this.el)[0];

            this.userInteract = new UI(this.element(), { preventScrolling: true });

            this.userInteract.on('dragStart', this.dragStartListener);
            this.userInteract.on('drag', this.dragMoveListener);
            this.userInteract.on('dragEnd', this.dragEndListener);

            this.userInteract.on('tap click', this.tapListener);
        },
        dragStart: function dragStart() {
            this.trigger('dragStart');
            this.railBounds = utils.bounds(this.elementRail);
        },
        dragEnd: function dragEnd(evt) {
            this.dragMove(evt);
            this.trigger('dragEnd');
        },
        dragMove: function dragMove(evt) {
            var dimension,
                bounds = this.railBounds = this.railBounds ? this.railBounds : utils.bounds(this.elementRail),
                percentage;

            if (this.orientation === 'horizontal') {
                dimension = evt.pageX;
                if (dimension < bounds.left) {
                    percentage = 0;
                } else if (dimension > bounds.right) {
                    percentage = 100;
                } else {
                    percentage = utils.between((dimension - bounds.left) / bounds.width, 0, 1) * 100;
                }
            } else {
                dimension = evt.pageY;
                if (dimension >= bounds.bottom) {
                    percentage = 0;
                } else if (dimension <= bounds.top) {
                    percentage = 100;
                } else {
                    percentage = utils.between((bounds.height - (dimension - bounds.top)) / bounds.height, 0, 1) * 100;
                }
            }

            var updatedPercent = this.limit(percentage);
            this.render(updatedPercent);
            // 时间进度条在拖动过程中，不需要更新数据 zhangzhe 2016-05-11
            if (!(evt.type === 'drag' && utils.hasClass(evt.currentTarget, 'jw-slider-time'))) {
                this.update(updatedPercent);
            }
            return false;
        },
        tap: function tap(evt) {
            this.railBounds = utils.bounds(this.elementRail);
            this.dragMove(evt);
        },

        limit: function limit(percentage) {
            // modules that extend Slider can set limits on the percentage (TimeSlider)
            return percentage;
        },
        update: function update(percentage) {
            this.trigger('update', { percentage: percentage });
        },
        render: function render(percentage) {
            percentage = Math.max(0, Math.min(percentage, 100));

            if (this.orientation === 'horizontal') {
                this.elementThumb.style.left = percentage + '%';
                this.elementProgress.style.width = percentage + '%';
            } else {
                this.elementThumb.style.bottom = percentage + '%';
                this.elementProgress.style.height = percentage + '%';
            }
        },
        updateBuffer: function updateBuffer(percentage) {
            if (percentage) {
                this.elementBuffer.style.width = percentage + '%';
            }
        },

        element: function element() {
            return this.el;
        }
    });

    return Slider;
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/view/components/slider.js
 ** module id = 187
 ** module chunks = 0
 **/